import { render, staticRenderFns } from "./form-settings.vue?vue&type=template&id=13589a1f&"
import script from "./form-settings.vue?vue&type=script&lang=js&"
export * from "./form-settings.vue?vue&type=script&lang=js&"
import style0 from "./form-settings.vue?vue&type=style&index=0&id=13589a1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports